import { useCallback } from 'react';

import { useClearRefinements, useInstantSearch } from 'react-instantsearch';

import { useTracking } from '@change-corgi/core-react/tracking';

import {
	INSTANT_SEARCH_LOCATION_CITY_FILTER,
	INSTANT_SEARCH_LOCATION_COUNTRY_CODE_FILTER,
} from 'src/app/pages/search/shared/consts';

type Result = ModelHookResult<
	{
		selectedLocation: string;
	},
	{
		clearSelectedLocation: () => void;
	}
>;

export function useClearSelectedLocation(): Result {
	const { indexUiState } = useInstantSearch();

	const track = useTracking();

	const { refine: clearRefine } = useClearRefinements({
		includedAttributes: [INSTANT_SEARCH_LOCATION_CITY_FILTER, INSTANT_SEARCH_LOCATION_COUNTRY_CODE_FILTER],
	});

	const [selectedLocation] =
		indexUiState.refinementList?.[INSTANT_SEARCH_LOCATION_CITY_FILTER] ||
		indexUiState.refinementList?.[INSTANT_SEARCH_LOCATION_COUNTRY_CODE_FILTER] ||
		[];

	return {
		data: {
			selectedLocation: selectedLocation || '',
		},
		actions: {
			clearSelectedLocation: useCallback(() => {
				if (selectedLocation) {
					void track('search', { q: indexUiState.query || '', context: 'clear_location_filter' });
					clearRefine();
				}
			}, [selectedLocation, track, indexUiState.query, clearRefine]),
		},
	};
}
